import { LoggerWarning } from '@rehaje/errors'
import { deprecatedWarning } from '@rehaje/shared'

import type { Locales } from '@rehaje/errors'

export class LoggerDeprecatedWarning extends LoggerWarning {
  static override locales: Locales = {
    'en-US':
      '%s API will be offline soon, ' +
      'it may cause your application to be unavailable, ' +
      'please migrate in time',
    'zh-CN': '%s API 即将下线，下线后可能会导致应用不可用，请尽快迁移',
    'zh-HK': '%s API 即將下線，下線後可能會導致應用不可用，请盡快迁移'
  }

  override name = 'LoggerDeprecatedWarning' as const

  constructor(apiName: string) {
    super(apiName)
    deprecatedWarning(apiName)
  }
}
